import React, { useEffect } from "react";
import "./landing.css";
import GrainOverlay from "./components/GrainOverlay";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import SectionIntro from "./components/SectionIntro";
import SectionPillars from "./components/SectionPillars";
import SectionPath from "./components/SectionPath";
import SectionTrust from "./components/SectionTrust";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import CursorRing from "./components/CursorRing";
import ScrollProgress from "./components/ScrollProgress";

export default function LandingPage() {
    // Iniezione Fontshare (General Sans) + Google Fonts IBM Plex Mono a runtime.
    // Nessuna modifica a index.html globale → font scoped alla landing.
    useEffect(() => {
        const specs = [
            { rel: "preconnect", href: "https://api.fontshare.com" },
            { rel: "preconnect", href: "https://cdn.fontshare.com", crossOrigin: "anonymous" },
            { rel: "preconnect", href: "https://fonts.googleapis.com" },
            { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" },
            { rel: "stylesheet", href: "https://api.fontshare.com/v2/css?f[]=general-sans@300,400,500,600,700&display=swap" },
            { rel: "stylesheet", href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@500;600&display=swap" },
        ];
        const created = specs.map((s) => {
            const el = document.createElement("link");
            Object.entries(s).forEach(([k, v]) => {
                if (v === undefined) return;
                if (k === "crossOrigin") el.crossOrigin = v;
                else el.setAttribute(k, v);
            });
            document.head.appendChild(el);
            return el;
        });
        return () => created.forEach((el) => el.remove());
    }, []);

    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <div className="lp-root" data-testid="landing-root">
            <ScrollProgress />
            <CursorRing />
            <GrainOverlay />
            <Nav />
            <main>
                <Hero
                    onPrimary={() => scrollTo("contatti")}
                    onSecondary={() => scrollTo("metodo")}
                />
                <SectionIntro />
                <SectionPillars />
                <SectionPath />
                <SectionTrust />
                <ContactForm />
            </main>
            <Footer />
        </div>
    );
}
